import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import { connect } from 'react-redux'
import { getCurrentUser } from 'state/selectors/userSelectors'

import { toggleTimer } from 'state/actions'

class TaskTimer extends Component {
	toggleTimer = _ => {
		this.props.toggleTimer(this.props.task)
	}

	isTimerRunning = _ => {
		if(!this.props.userData.sessions){
			return false
		}

		return this.props.userData.sessions.find(sessionId => {
			const session = this.props.sessions[sessionId]

			if(session){
				return (session.task_id == this.props.task.id && !session.stopped_at)
			}else{
				return false
			}
		})
	}

	render() {
		const isTimerRunning = this.isTimerRunning()

		let className = "task-timer tooltip-trigger"

		if(isTimerRunning){
			className += ' active'
		}

		return (
			<button className={className} onClick={this.toggleTimer}>
				<Icon name="fe-clock" />
				<div className="tooltip">
					{ isTimerRunning ? 'Stop' : 'Start' } timer
				</div>
			</button>
		)
	}
}

const mapStateToProps = state => {
	return {
		userData: getCurrentUser(state),
		sessions: state.account.entities.sessions ? state.account.entities.sessions : {}
	};
}

export default connect(mapStateToProps, { toggleTimer })(TaskTimer)


// WEBPACK FOOTER //
// ./src/sections/projects/project/project-tasks/task/task-timer.jsx